import React from "react";
import gifImage from "../assets/1p_gif/1.gif"; // GIF 이미지 경로
import "./Main.css"

function Main(){
    return (
        <main className="main-section">
            <div className="main-section-gif-container">
            <img src={gifImage} alt="채움기획 메인 애니메이션 사진" />
            </div>
        </main>
    );
}

export default Main